import { GET_ENTITY_SCHEMA, getPageQuery } from '../application/query';
import getErrorMessage from './get-error-message';

const getPageData = async ({ apolloClient, itemId, itemEntity, isPreview = true }) => {
  try {
    const {
      data: { entitySchema }
    } = await apolloClient.query({
      query: GET_ENTITY_SCHEMA,
      variables: { id: itemEntity }
    });

    const { data } = await apolloClient.query({
      query: getPageQuery({ ...entitySchema, isPreview }),
      variables: { id: itemId }
    });
    return data;
  } catch (error) {
    return getErrorMessage(error);
  }
};

export default getPageData;
